import { BaseContainerModel } from '../../base-container.model';
import { bl_aat_claim_ocr_doc_queue_RowClass } from '../../../dbschema';

export class ClaimOcrDocQueueContainerModel extends BaseContainerModel {
  bl_aat_claim_ocr_doc_queue: bl_aat_claim_ocr_doc_queue_RowClass = new bl_aat_claim_ocr_doc_queue_RowClass();
}
